import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComingSoonCta from '@/components/feature/ComingSoonCta';

const tracks = [
  { number: '01', title: 'Buenos días, mundo', description: 'despertar suave con la primera luz' },
  { number: '02', title: 'Rayos de sol', description: 'brillo ligero, como luz entre hojas' },
  { number: '03', title: 'La hora del juego', description: 'juguetón, con rebote suave' },
  { number: '04', title: 'Pequeños descubrimientos', description: 'asombro, tono explorador' },
  { number: '05', title: 'La sonrisa del bebé', description: 'calidez tierna' },
  { number: '06', title: 'Mariposas en el jardín', description: 'ligero, aleteo suave' },
  { number: '07', title: 'Mañana de primavera', description: 'fresco, como una brisa suave' },
  { number: '08', title: 'El desayuno feliz', description: 'cálido, sensación de hogar' },
  { number: '09', title: 'Corriendo por el pasto', description: 'movimiento juguetón, alegría' },
  { number: '10', title: 'Hasta la próxima siesta', description: 'cierre suave de la mañana' },
];

const heroImage = 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20playing%20gently%20with%20her%20happy%20baby%20on%20a%20soft%20blanket%20in%20a%20bright%20warm%20morning%20room%2C%20warm%20morning%20light%20streaming%20through%20sheer%20curtains%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20joyful%20and%20peaceful%20atmosphere%2C%20mother%20smiling%20genuinely%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20soft%20morning%20light%2C%20gentle%20play%20and%20awakening%2C%20soft%20textures%2C%20natural%20wooden%20toys&width=1400&height=600&seq=274&orientation=landscape';

export default function AlbumDespertarSuave() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Reading Progress Bar */}
      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      {/* Hero Section */}
      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('album_despertar.tag')}
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                {t('album_despertar.title1')}
                <br />
                <span className="font-bold">{t('album_despertar.title2')}</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('album_despertar.hero.desc')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-sun-line text-xs" />
                  {t('album_despertar.badge1')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-user-smile-line text-xs" />
                  {t('album_despertar.badge2')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-music-line text-xs" />
                  {t('album.temas_badge')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-download-cloud-line text-xs" />
                  {t('album.descarga_badge')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('album.uso_badge')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$9.99</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('common.usd')} — {t('common.pago_unico')}</span>
              </div>
              <ComingSoonCta />
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt="Madre y bebé jugando en la mañana con luz suave"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Sinopsis */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-sun-line text-3xl text-cream" />
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-cream leading-tight mb-8">
            {t('album_despertar.sinopsis.title')}
          </h2>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            No toda la música es para dormir. Hay momentos del día que necesitan su propio sonido: el despertar de las siestas, el tiempo de juego libre, la mañana de los días felices. Esos momentos también merecen música diseñada específicamente para ellos.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            El Despertar Alegre fue creado para acompañar la activación sin sobreestimulación. Melodías alegres pero no ruidosas. Instrumentos naturales que energizan sin disparar el cortisol. Ritmos lentos que dicen: podés despertarte, podés explorar, el mundo es seguro y divertido.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed">
            Porque el tono emocional del día de tu bebé se construye en los primeros minutos después de despertar. Y esos minutos merecen la mejor música posible.
          </p>
        </div>
      </section>

      {/* Neurociencia */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
            <div className="w-full md:w-1/2">
              <div className="w-14 h-14 rounded-2xl bg-[#AAB7A3]/20 flex items-center justify-center mb-6">
                <i className="ri-brain-line text-2xl text-[#AAB7A3]" />
              </div>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-6">
                {t('album_despertar.ciencia.title')}
              </h2>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                Entre los 3 y los 12 meses, el cerebro de tu bebé está en plena explosión de conexiones sinápticas. Cada sonido, cada movimiento, cada experiencia forma nuevas redes neuronales. El desafío no es estimularlo — es estimularlo en la medida justa.
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                La sobreestimulación es tan problemática como la infraestimulación. Un cerebro sobreestimulado dispara cortisol, cierra la ventana de aprendizaje y no puede consolidas las nuevas conexiones. Por eso la música de activación no puede ser caótica, brillante o rápida.
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                El Despertar Alegre usa instrumentos naturales —piano y xilófono— porque estas tímbricas activan el sistema auditivo sin saturarlo, generando un estado de alerta positivo sin sobrecargar el sistema nervioso.
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed">
                El tono emocional del día no es accidental. Es el resultado de los primeros estímulos que el cerebro recibe al despertar. Esta música es el primer estímulo que elegís para tu bebé. Y es exactamente el correcto.
              </p>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sand/30">
                <h3 className="font-serif text-2xl font-bold text-[#8B6F5C] mb-6">
                  ¿Qué incluye?
                </h3>
                <ul className="flex flex-col gap-4">
                  {[
                    '10 temas de audio de alta calidad',
                    'Instrumentos naturales: piano y xilófono',
                    'Melodías alegres sin sobreestimulación auditiva',
                    'Para despertar de siestas',
                    'Para tiempo de juego libre',
                    'Para las mañanas',
                    'Diseñado para bebés de 3 a 12 meses',
                    'Descarga inmediata tras la compra',
                    'Uso ilimitado en todos tus dispositivos',
                  ].map((item) => (
                    <li key={item} className="flex items-center gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#AAB7A3]/20 flex-shrink-0">
                        <i className="ri-check-line text-[#AAB7A3] text-sm" />
                      </div>
                      <span className="font-sans text-sm text-[#3D2B1F]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Track List */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              {t('album.lista_temas')}
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('album_despertar.tracks_title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              Cada tema es un pequeño mundo de sonidos que invita al juego, a la curiosidad y a la alegría. Sin prisa. Sin ruido. Solo el ritmo exacto que tu bebé necesita.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-sand/40 overflow-hidden">
            {tracks.map((track, index) => (
              <div
                key={track.number}
                className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 ${index !== tracks.length - 1 ? 'border-b border-sand/20' : ''}`}
              >
                <span className="font-sans text-sm font-medium text-[#5C4A3A] flex-shrink-0 w-8">
                  {track.number}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C]">
                    {track.title}
                  </h3>
                  <p className="font-sans text-sm text-[#5C4A3A] mt-0.5">
                    {track.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cierre emocional */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-sun-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            &ldquo;No todos los momentos del día necesitan calma — algunos necesitan luz. Este álbum es para esos minutos después de la siesta, cuando tu bebé abre los ojos y el mundo empieza de nuevo, pequeño y entero. Es la banda sonora de las mañanas que sí funcionan, de los juegos en el piso, de las risas que no se explican. Ponelo, y mirá cómo cambia el aire de la habitación.&rdquo;
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            — Mercedes, NeuroBabys
        </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('album_despertar.cta.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('album_despertar.cta.desc')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$9.99</span>
            <span className="font-sans text-base text-[#5C4A3A]">USD</span>
          </div>
          <ComingSoonCta size="lg" className="mb-4" />
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('album.descarga_footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}